import { Mark } from '@tiptap/react';

export const NoteEvidenceHighlight = Mark.create({
  name: 'noteEvidenceHighlight',

  parseHTML() {
    return [
      {
        tag: 'span.note-evidence-highlight',
      },
    ];
  },

  renderHTML() {
    return [
      'span',
      {
        class: 'note-evidence-highlight rounded-sm bg-blue-100 dark:bg-blue-900/30',
        'data-note-evidence': '',
      },
      0,
    ];
  },
});
